import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './form.module.scss';

const FormLabel = ({ id, subtitle, children, ...props }) => {
  const classes = applyClasses(props, styles);
  return (
    <div
      id={id}
      className={cn(styles.formLabel, classes)}
      {...applyProps(props)}
    >
      {/* eslint-disable-next-line react/prop-types */}
      <div className={cn(styles.title, props.className)}>{children}</div>
      {subtitle && (
        // eslint-disable-next-line react/prop-types
        <div className={cn(styles.subtitle, props.subtitleClassName)}>
          {subtitle}
        </div>
      )}
    </div>
  );
};

FormLabel.propTypes = {
  /** The ID of the div element. Useful to select the label during testing. */
  id: PropTypes.string,
  /** The smaller, unbolded text in the label */
  subtitle: PropTypes.any,
  /** The main bold text in the label */
  children: PropTypes.any,
};

FormLabel.defaultProps = {
  subtitle: undefined,
  children: undefined,
};

export default FormLabel;
